import { render, staticRenderFns } from "./VButtonPlusBlock.vue?vue&type=template&id=9ce9d24c&"
import script from "./VButtonPlusBlock.vue?vue&type=script&lang=js&"
export * from "./VButtonPlusBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports